// generated from 6_342_854 samples

import { z } from "zod";
import { addedEmailAddressTriggerGetSchema } from "./addedEmailAddressTriggerGetSchema";
import { attributeUpdatedTriggerGetSchema } from "./attributeUpdatedTriggerGetSchema";
import { behaviorBaseTriggerGetSchema } from "./behaviorBaseTriggerGetSchema";
import { cartUpdatedEventTriggerGetSchema } from "./cartUpdatedEventTriggerGetSchema";
import { catalogBackInStockTriggerGetSchema } from "./catalogBackInStockTriggerGetSchema";
import { catalogPriceDropTriggerGetSchema } from "./catalogPriceDropTriggerGetSchema";
import { checkoutCompletedEventTriggerGetSchema } from "./checkoutCompletedEventTriggerGetSchema";
import { checkoutStartedEventTriggerGetSchema } from "./checkoutStartedEventTriggerGetSchema";
import { enteredGeoFenceTriggerGetSchema } from "./enteredGeoFenceTriggerGetSchema";
import { executedWorkflowStepTriggerGetSchema } from "./executedWorkflowStepTriggerGetSchema";
import { interactedWithCampaignTriggerGetSchema } from "./interactedWithCampaignTriggerGetSchema";
import { interactedWithCampaignPushOnlyTriggerGetSchema } from "./interactedWithCampaignPushOnlyTriggerGetSchema";
import { interactedWithCardTriggerGetSchema } from "./interactedWithCardTriggerGetSchema";
import { interactedWithInternalStepTriggerGetSchema } from "./interactedWithInternalStepTriggerGetSchema";
import { interactedWithLocationSetTriggerGetSchema } from "./interactedWithLocationSetTriggerGetSchema";
import { interactedWithWorkflowStepTriggerGetSchema } from "./interactedWithWorkflowStepTriggerGetSchema";
import { interactedWithWorkflowStepInternalCanvasTriggerGetSchema } from "./interactedWithWorkflowStepInternalCanvasTriggerGetSchema";
import { landingPageFormSubmittedTriggerGetSchema } from "./landingPageFormSubmittedTriggerGetSchema";
import { landingPageSurveySubmittedTriggerGetSchema } from "./landingPageSurveySubmittedTriggerGetSchema";
import { madeAnyPurchaseTriggerGetSchema } from "./madeAnyPurchaseTriggerGetSchema";
import { performedCampaignExceptionTriggerGetSchema } from "./performedCampaignExceptionTriggerGetSchema";
import { performedConversionTriggerGetSchema } from "./performedConversionTriggerGetSchema";
import { performedCustomEventTriggerGetSchema } from "./performedCustomEventTriggerGetSchema";
import { performedCustomEventWithNestedObjectTriggerGetSchema } from "./performedCustomEventWithNestedObjectTriggerGetSchema";
import { performedOrderPlacedTriggerGetSchema } from "./performedOrderPlacedTriggerGetSchema";
import { potentiallyEnteredWorkflowTriggerGetSchema } from "./potentiallyEnteredWorkflowTriggerGetSchema";
import { purchasedProductTriggerGetSchema } from "./purchasedProductTriggerGetSchema";
import { purchasedProductWithNestedObjectTriggerGetSchema } from "./purchasedProductWithNestedObjectTriggerGetSchema";
import { sentLineInboundMessageTriggerGetSchema } from "./sentLineInboundMessageTriggerGetSchema";
import { sentSmsInboundMessageTriggerGetSchema } from "./sentSmsInboundMessageTriggerGetSchema";
import { sentWhatsAppInboundMessageTriggerGetSchema } from "./sentWhatsAppInboundMessageTriggerGetSchema";
import { subscriptionGroupStateChangedTriggerGetSchema } from "./subscriptionGroupStateChangedTriggerGetSchema";
import { subscriptionStateChangedTriggerGetSchema } from "./subscriptionStateChangedTriggerGetSchema";
import { usedAppTriggerGetSchema } from "./usedAppTriggerGetSchema";

export const triggerGetSchema = z.discriminatedUnion("event_type", [
  addedEmailAddressTriggerGetSchema,
  attributeUpdatedTriggerGetSchema,
  behaviorBaseTriggerGetSchema,
  cartUpdatedEventTriggerGetSchema,
  catalogBackInStockTriggerGetSchema,
  catalogPriceDropTriggerGetSchema,
  checkoutCompletedEventTriggerGetSchema,
  checkoutStartedEventTriggerGetSchema,
  enteredGeoFenceTriggerGetSchema,
  executedWorkflowStepTriggerGetSchema,
  interactedWithCampaignTriggerGetSchema,
  interactedWithCampaignPushOnlyTriggerGetSchema,
  interactedWithCardTriggerGetSchema,
  interactedWithInternalStepTriggerGetSchema,
  interactedWithLocationSetTriggerGetSchema,
  interactedWithWorkflowStepTriggerGetSchema,
  interactedWithWorkflowStepInternalCanvasTriggerGetSchema,
  landingPageFormSubmittedTriggerGetSchema,
  landingPageSurveySubmittedTriggerGetSchema,
  madeAnyPurchaseTriggerGetSchema,
  performedCampaignExceptionTriggerGetSchema,
  performedConversionTriggerGetSchema,
  performedCustomEventTriggerGetSchema,
  performedCustomEventWithNestedObjectTriggerGetSchema,
  performedOrderPlacedTriggerGetSchema,
  potentiallyEnteredWorkflowTriggerGetSchema,
  purchasedProductTriggerGetSchema,
  purchasedProductWithNestedObjectTriggerGetSchema,
  sentLineInboundMessageTriggerGetSchema,
  sentSmsInboundMessageTriggerGetSchema,
  sentWhatsAppInboundMessageTriggerGetSchema,
  subscriptionGroupStateChangedTriggerGetSchema,
  subscriptionStateChangedTriggerGetSchema,
  usedAppTriggerGetSchema,
]);
